import React, { useState } from "react";
import { Box, Stack } from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";
import { PagePaper } from "@/components/Paper/PagePaper";
import { PageTitle } from "@/components/Title";
import ContactMailIcon from "@mui/icons-material/ContactMail";
import { OrderListGrid } from "@/features/dmManagement/components/OrderListGrid";
import { StatusFilter } from "@/features/dmManagement/components/StatusFilter";
import { ORDER_STATUS_OPTIONS } from "@/features/dmManagement/types/constants";
import { useOrders } from "@/features/dmManagement/hooks/useOrders";
import { useRefreshCooldown } from "@/features/dmManagement/hooks/useRefreshCooldown";
import { Button, ButtonVariantOption } from "@/components/Button";
import { LinkButton } from "@/components/Button/LinkButton";
import { SizingWrapperStyle } from "@/components/Wrapper";

export const OrderListPage: React.FC = () => {
  const [statusFilter, setStatusFilter] = useState("");
  const { orders, isLoading, mutate } = useOrders(
    statusFilter ? { status: statusFilter } : undefined
  );
  const { coolDownTime, handleRefresh } = useRefreshCooldown(() => {
    void mutate();
  });

  return (
    <PagePaper>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        mb={2}
      >
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <ContactMailIcon sx={{ mr: 1 }} fontSize="large" />
          <PageTitle>DM管理</PageTitle>
          <Box sx={{ ml: 3 }}>
            {coolDownTime ? (
              <Button
                label={`残り${coolDownTime}秒`}
                onClick={handleRefresh}
                variant={ButtonVariantOption.Outlined}
                disabled
                size={SizingWrapperStyle.INHERIT}
              />
            ) : (
              <Button
                label="更新"
                onClick={handleRefresh}
                variant={ButtonVariantOption.Outlined}
                startIcon={<RefreshIcon />}
                size={SizingWrapperStyle.INHERIT}
              />
            )}
          </Box>
        </Box>
        <Stack direction="row" spacing={1}>
          <LinkButton
            variant={ButtonVariantOption.Outlined}
            href="/dmManagement/designs"
            wrapperSize={SizingWrapperStyle.INHERIT}
          >
            デザインデータ管理
          </LinkButton>
          <LinkButton
            variant={ButtonVariantOption.Contained}
            href="/dmManagement/orders/new"
            wrapperSize={SizingWrapperStyle.INHERIT}
          >
            注文する
          </LinkButton>
        </Stack>
      </Stack>
      <Box mb={2}>
        <StatusFilter
          value={statusFilter}
          onChange={setStatusFilter}
          options={ORDER_STATUS_OPTIONS}
          labelId="order-status-filter-label"
        />
      </Box>
      <OrderListGrid orders={orders ?? []} isLoading={isLoading} />
    </PagePaper>
  );
};
